<template>
    <a-modal
      :visible="visible"
      title="选择发文类型"
      :centered="true"
      :footer="null"
      width="400px"
      @cancel="handleClose"
    >
      <a-row>
        <a-col
          :span="12"
          @click="handleOk((type = 1))"
          style="
            cursor: pointer;
            border-right: 1px solid #e8e8e8;
            text-align: center;
            padding-right: 10px;
            padding-top:20px;
            padding-bottom:13px
          "
        >
          <span class="icon-wrap">
            <span
              class="icon icon-article-writing"
              style="margin: 0 auto"
            ></span>
          </span>
          <div style="color:#333;font-weight: 500;font-size:16px;margin-top:10px">文章投稿</div>
          <div style="color:#666;">官方审核，优秀的内容被更多人浏览</div>
        </a-col>
        <a-col
          :span="10"
          @click="handleOk((type = 2))"
          style="cursor: pointer; text-align: center; padding-left: 30px; padding-top:20px;padding-bottom:13px" 
        >
          <span class="icon-wrap">
            <span class="icon icon-bbs-vote" style="margin: 0 auto"></span>
          </span>
          <div style="color:#333;font-weight: 500;font-size:16px;margin-top:10px">社区发帖</div>
          <div style="color:#666;">在知图社区里畅所欲言</div>
        </a-col>
      </a-row>
    </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
    props:['visible'],
    setup(props,context) {
        const router = useRouter();
        const handleOk = (type)=>{
            handleClose();
            router.push({
                path: "/pub",
                query: { type: type },
            });
        }

        const handleClose=()=>{
            context.emit('close')
        }

        return {
            handleOk,
            handleClose,
        }
    }
});
</script>

<style>

</style>